// Generado por scripts/generate-env.js. No editar.
export const appConfig = {
  apiBaseUrl: "https://api.iofesign.com",
  recaptchaSiteKey: "6LeEs94ZAAAAAFNT6nJ5JMlzeRmH5TYw3-VAg-oA"
};
